import * as React from "react";
import { Select, type SelectProps } from "../Select/Select";
import { STATES, TERRITORIES, ARMED_FORCES } from "./states";

interface StateSelectProps extends Omit<SelectProps, "options" | "label"> {
  label?: string;
  hasTerritories?: boolean;
  hasArmedForces?: boolean;
}

function StateSelectInner(
  props: StateSelectProps,
  forwardedRef: React.ForwardedRef<HTMLSelectElement>
) {
  const { hasArmedForces, hasTerritories, label = "State", ...rest } = props;
  let stateOptions = [...STATES];

  if (hasTerritories) {
    stateOptions = [...stateOptions, ...TERRITORIES];
  }

  if (hasArmedForces) {
    stateOptions = [...stateOptions, ...ARMED_FORCES];
  }

  return (
    <Select {...rest} ref={forwardedRef} label={label} options={stateOptions} />
  );
}

const StateSelect = React.forwardRef<HTMLSelectElement, StateSelectProps>(
  StateSelectInner
);

StateSelect.displayName = "StateSelect";

export { StateSelect };
